import { State } from '../../types';

export const vermont: State = {
  name: 'Vermont',
  abbreviation: 'VT',
  terms: [
    {
      word: 'Barre',
      phonetic: 'BARRY',
      // audioUrl: '/audio/barre.mp3',
      description: 'Despite its French appearance, this city is pronounced as "Barry."'
    },
    {
      word: 'Calais',
      phonetic: 'CAL-iss',
      // audioUrl: '/audio/calais.mp3',
      description: 'Unlike the French city, this town is pronounced "CAL-iss."'
    },
    {
      word: 'Charlotte',
      phonetic: 'shar-LOT',
      // audioUrl: '/audio/charlotte.mp3',
      description: 'This town is pronounced "shar-LOT," differing from the North Carolina city.'
    },
    {
      word: 'Chittenden',
      phonetic: 'CHIT-en-den',
      // audioUrl: '/audio/chittenden.mp3',
      description: 'The county name is pronounced "CHIT-en-den," with emphasis on the first syllable.'
    },
    {
      word: 'Londonderry',
      phonetic: 'LUN-dun-DAIR-ee',
      // audioUrl: '/audio/londonderry.mp3',
      description: 'This town is pronounced "LUN-dun-DAIR-ee," with emphasis on the first and third syllables.'
    },
    {
      word: 'Montpelier',
      phonetic: 'mont-PEEL-yer',
      // audioUrl: '/audio/montpelier.mp3',
      description: 'The capital city is pronounced "mont-PEEL-yer," not "mon-pell-yay."'
    },
    {
      word: 'Norwich',
      phonetic: 'NOR-itch',
      // audioUrl: '/audio/norwich.mp3',
      description: 'This town is pronounced "NOR-itch," with a silent "w."'
    },
    {
      word: 'Vershire',
      phonetic: 'VER-shire',
      // audioUrl: '/audio/vershire.mp3',
      description: 'This town is pronounced "VER-shire," with emphasis on the first syllable.'
    },
    {
      word: 'Worcester',
      phonetic: 'WUSS-ter',
      // audioUrl: '/audio/worcester.mp3',
      description: 'This town is pronounced "WUSS-ter," with a silent "ce."'
    }
  ]
};